import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { Scanner } from 'src/app/model/scanner';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { UserService } from 'src/app/services/user.service';
import { Printer } from '../../../model/printer';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PrinterService } from '../../../services/printer.service';
import { async } from '@angular/core/testing';
import { AuthService } from '../../../services/auth.service';
import { PrintWebSocketService } from '../../../services/print-web-socket.service';

@Component({
  selector: 'app-printer-search',
  templateUrl: './printer-search.component.html',
  styleUrls: ['./printer-search.component.css']
})
export class PrinterSearchComponent implements OnInit {

  loading: boolean;
  loadingAction: boolean;
  printers: Printer[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = ['Name', 'Star'];
  dataSource = new MatTableDataSource([]);
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;

  constructor(public dialog: MatDialog
    , private router: Router
    , private authService: AuthService
    , private printerService: PrinterService
    , private printWebSocketService: PrintWebSocketService
    , private menuService: MenuService
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Impresora', 'Búsqueda');
  }

  ngOnInit(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<Printer>) {
    this.printers = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.printers);
  }

  onStartSearch() {
    this.loading = true;
  }

  new(): void {
    this.router.navigate(['printer-edit']);
  }

  edit(printer: Printer): void {
    this.router.navigate(['printer-edit', printer.Id]);
  }

  async add(printer: Printer) {
    try {
      this.loadingAction = true;
      await this.printerService.printerUserUpdate(
          this.authService.getUserId(),
          printer.Id);

      this.printWebSocketService.start(printer);
      this.notificationToastService.success('Se asignó la impresora correctamente', 'Impresora');
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Impresora');
    } finally {
      this.loadingAction = false;
    }
  }

  delete(printer: Printer): void {
    this.confirmDialogService.confirm('Impresora', 'Está seguro que desea elimnar la impresora?'
    , 'Sí', 'No').subscribe(async (value) => {
      if (value) {
        try {
          this.loadingAction = true;
          await this.printerService.printerDelete(printer);
          await this.searchFilter.search();
        } catch (err) {
          this.notificationToastService.error(JSON.stringify(err.error), 'Impresora');
        } finally {
          this.loadingAction = false;
        }
      }
    });
  }
}
